import { render, staticRenderFns } from "./UpdateProjectForm.vue?vue&type=template&id=dc766468&scoped=true&"
import script from "./UpdateProjectForm.vue?vue&type=script&lang=ts&"
export * from "./UpdateProjectForm.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateProjectForm.vue?vue&type=style&index=0&id=dc766468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc766468",
  null
  
)

export default component.exports